import React from "react";
import { Input } from "../../ui/Input";

export const CharitiesForm = React.memo(({formData, onChange, isReadOnly, isReport}) => {

    return (
        <>
            <Input
                label={"Full Name"}
                name={"uboCharityName"}
                value={formData.uboCharityName}
                onChange={onChange}
                disabled={isReadOnly}
                isReport={isReport}
                required
            />

            <Input
                label={"Charity Number"}
                name={"uboCharityNumber"}
                value={formData.uboCharityNumber}
                onChange={onChange}
                disabled={isReadOnly}
                isReport={isReport}
                required
            />

            <Input
                label={"Address"}
                name={"uboCharityAddress"}
                value={formData.uboCharityAddress}
                onChange={onChange}
                disabled={isReadOnly}
                isReport={isReport}
                required
            />

            <Input 
                label={"Nature/Purpose of Charity"}
                name={"uboCharityPurpose"}
                value={formData.uboCharityPurpose}
                onChange={onChange}
                disabled={isReadOnly}
                isReport={isReport}
            />

            <Input
                label={"Name(s) of Trustee(s)"}
                name={"uboCharityTrustees"}
                value={formData.uboCharityTrustees}
                onChange={onChange}
                disabled={isReadOnly}
                isReport={isReport}
            />

            <Input 
                label={"Names of Beneficiaries"}
                name={"uboCharityBeneficiaries"}
                value={formData.uboCharityBeneficiaries}
                onChange={onChange}
                disabled={isReadOnly}
                isReport={isReport}
            />

            <Input 
                label={"Class of Beneficiaries"}
                name={"uboCharityBeneficiaryClass"}
                value={formData.uboCharityBeneficiaryClass}
                onChange={onChange}
                disabled={isReadOnly}
                isReport={isReport}
            />

        </>
    );
});